import React, { useState } from "react";
import Select from "react-select";
import * as Components from "../../../components/all";

import Chart from "react-apexcharts";

import { useNavigate } from "react-router-dom";
import { Slide } from "pure-react-carousel";
import { TbActivityHeartbeat } from "react-icons/tb";
import { AiOutlineUserAdd } from "react-icons/ai";
import AnychartReactMin from "anychart-react";

export default function Trends() {
	const navigate = useNavigate();
	// eslint-disable-next-line no-unused-vars
	const [loading, setLoading] = useState(false);

	// Select Tag Types
	const [activityType, setActivityType] = useState("30");
	const [registrationsType, setRegistrationsType] = useState("30");
	const [trendType, setTrendType] = useState("all-time");

	// Trend Data
	var trendsData = {
		allTime: [
			{
				year: "2015",
				activity: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
				registrations: [11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
				clicks: [1111, 112, 1113, 14, 1115, 61, 71, 81, 91, 110, 111, 112],
			},
			{
				year: "2016",
				activity: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120],
				registrations: [
					110, 210, 130, 410, 150, 160, 710, 801, 190, 1100, 1110, 1210,
				],
				clicks: [15, 50, 35, 50, 50, 515, 715, 815, 915, 150, 155, 125],
			},
			{
				year: "2017",
				activity: [50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 650],
				registrations: [20, 100, 150, 1, 210, 100, 150, 100, 510, 1, 150, 1650],
				clicks: [52, 120, 152, 220, 252, 20, 32, 420, 20, 2, 20, 20],
			},
			{
				year: "2018",
				activity: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
				registrations: [11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
				clicks: [511, 112, 513, 14, 115, 561, 71, 81, 91, 110, 111, 112],
			},
			{
				year: "2019",
				activity: [1200, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120],
				registrations: [
					110, 210, 130, 410, 150, 160, 710, 801, 190, 1100, 1110, 1210,
				],
				clicks: [15, 50, 35, 50, 50, 55, 75, 85, 95, 150, 155, 125],
			},
			{
				year: "2020",
				activity: [50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 650],
				registrations: [
					520, 100, 150, 1, 210, 100, 150, 1400, 510, 1, 5150, 1650,
				],
				clicks: [52, 120, 152, 220, 252, 320, 352, 420, 250, 502, 520, 620],
			},
			{
				year: "2021",
				activity: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
				registrations: [11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
				clicks: [111, 112, 113, 14, 115, 61, 71, 81, 91, 110, 111, 112],
			},
			{
				year: "2022",
				activity: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120],
				registrations: [
					110, 210, 130, 410, 150, 160, 710, 801, 190, 1100, 1110, 1210,
				],
				clicks: [15, 50, 35, 50, 50, 55, 75, 85, 95, 150, 155, 125],
			},
			{
				year: "2023",
				activity: [500, 1000, 2000, 2500, 30, 35, 40, 40, 500, 550, 600, 500],
				registrations: [
					500, 1000, 2000, 2500, 30, 35, 40, 40, 500, 550, 600, 500,
				],
				clicks: [52, 120, 152, 220, 252, 320, 352, 420, 250, 502, 520, 620],
			},
		],
		userActivity: {
			last30Days: 2000,
			last6Months: 30500,
			lastYear: 71200,
		},
		newRegistrations: {
			last30Days: 200,
			last6Months: 3000,
			lastYear: 7200,
		},
		cityTrendData: [
			{ city: "Islamabad", activity: 4000 },
			{ city: "Lahore", activity: 3000 },
			{ city: "Karachi", activity: 1000 },
			{ city: "Rawalpindi", activity: 2000 },
			{ city: "Gujrat", activity: 1500 },
			{ city: "Mandibahauddin", activity: 3000 },
		],
	};

	// settings
	var settings = {
		selectStyles: {
			control: (provided, state) => ({
				...provided,
				minHeight: "30px",
				height: "30px",
				boxShadow: state.isFocused ? null : null,
			}),

			valueContainer: (provided, state) => ({
				...provided,
				height: "30px",
				padding: "0 8px 0 8px",
			}),

			input: (provided, state) => ({
				...provided,
				margin: "0px",
			}),

			indicatorSeparator: (state) => ({
				display: "none",
			}),

			indicatorsContainer: (provided, state) => ({
				...provided,
				height: "30px",
			}),
		},
		yearlyTrendGraph: {
			options: {
				chart: {
					type: "area",
					stacked: false,
					height: "90%",
					zoom: {
						type: "x",
						enabled: true,
						autoScaleYaxis: true,
					},
					toolbar: {
						autoSelected: "zoom",
						tools: {
							download: true,
							selection: false,
							zoom: false,
							zoomin: true,
							zoomout: true,
							pan: false,
							reset: true,
						},
					},
				},
				dataLabels: {
					enabled: false,
				},
				legend: {
					show: false,
				},
				markers: {
					size: 4,
					colors: undefined,
					strokeColors: "#fff",
					strokeWidth: 0,
					fillOpacity: 1,
					discrete: [],
					shape: "circle",
					showNullDataPoints: true,
					hover: {
						sizeOffset: 3,
					},
				},
				fill: {
					type: "gradient",
					gradient: {
						shadeIntensity: 1,
						inverseColors: false,
						opacityFrom: 0.5,
						opacityTo: 0.2,
						stops: [10, 100],
					},
				},
				yaxis: {
					labels: {
						formatter: function (val) {
							return val.toFixed(0) + "k";
						},
					},
				},
				xaxis: {
					categories:
						trendType === "all-time"
							? [
									"2015",
									"2016",
									"2017",
									"2018",
									"2019",
									"2020",
									"2021",
									"2022",
									"2023",
							  ]
							: [
									"Jan",
									"Feb",
									"Mar",
									"Apr",
									"May",
									"Jun",
									"Jul",
									"Aug",
									"Sep",
									"Oct",
									"Nov",
									"Dec",
							  ],
				},
				stroke: {
					curve: "smooth",
					lineCap: "butt",
					width: 2,
					dashArray: 0,
				},
			},
		},
		cityTrendGraph: {
			width: "100%",
			height: 460,
			type: "pie3d",
			data: trendsData.cityTrendData.map((x) => [x.city, x.activity]),
			credits: false,
			yAxis: [
				1,
				{
					orientation: "right",
					enabled: true,
					labels: {
						format: "{%Value}{decimalPoint:\\,}",
						fontColor: "red",
					},
				},
			],
			legend: {
				padding: 20,
				// positionMode: "outside",
				// itemsLayout: "horizontal-expandable",
				// position: "left",
				// align: "bottom",
			},
			lineMarker: {
				value: 4.5,
			},
			palette: {
				type: "distinct",
				items: [
					"#99FFCD",
					"#219CF6",
					"#FFF56D",
					"#FFD36E",
					"#219CF6",
					"#9FB4FF",
					"#FFF56D",
					"#99FFCD",
					"#9FB4FF",
				],
			},
			startAngle: 0,
			radius: "100%",
			innerRadius: "50%",
		},
	};

	return loading === true ? (
		<Components.Loader />
	) : (
		<div
			className="Trends
            overflow-x-hidden overflow-y-auto 
            h-full
            w-full
            sm:p-3 md:p-5
            flex flex-col
            "
		>
			{/* TOP CARDS ROW */}
			<div className="TOP-CARDS flex flex-col sm:flex-row sm:items-stretch sm:justify-between sm:flex-wrap">
				{/* card 1 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="
					min-h-[220px]
					sm:min-w-[350px] flex-1
                    p-5 m-2
					overflow-hidden
                    rounded-md
                    bg-white 
                    flex flex-col
                    duration-150 ease-in-out
                    "
				>
					{/* heading */}
					<div
						className="
							w-full
							px-2 pb-7 
							flex 
							items-center justify-between 
							flex-wrap
							"
					>
						<div className="flex items-center">
							<div
								className="
									h-6 w-6
									flex items-center justify-center
									rounded-full
                                    bg-[#dfe6ff] 
                                    text-main
									"
							>
								<TbActivityHeartbeat />
							</div>
							<h1 className="ml-2 text-darker">User Activity</h1>
						</div>

						<Select
							className="text-sm"
							styles={settings.selectStyles}
							options={[
								{ value: "30", label: "Last 30 Days" },
								{ value: "6", label: "Last 6 Months" },
								{ value: "12", label: "Last Year" },
							]}
							defaultValue={{ value: "30", label: "Last 30 Days" }}
							onChange={(e) => setActivityType(e.value)}
						/>
					</div>

					{/* data */}
					<div className="my-auto w-full">
						<div className="w-fit mx-auto">
							<h1 className="text-3xl font-medium tracking-tighter text-center">
								{activityType === "30" &&
									trendsData.userActivity.last30Days.toLocaleString()}
								{activityType === "6" &&
									trendsData.userActivity.last6Months.toLocaleString()}
								{activityType === "12" &&
									trendsData.userActivity.lastYear.toLocaleString()}

								<span className="text-base tracking-normal ml-2">Visits</span>
							</h1>
							<h2
								className="text-dark 
											mt-1 
											text-center
											"
							>
								Activity in parking spaces
							</h2>
						</div>
					</div>
				</div>

				{/* card 2 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="
					min-h-[220px]
					sm:min-w-[350px] flex-1
                    p-5 m-2
					overflow-hidden
                    rounded-md
                    bg-white 
                    flex flex-col
                    duration-150 ease-in-out
                    "
				>
					{/* heading */}
					<div
						className="
							w-full
							px-2 pb-7 
							flex 
							items-center justify-between 
							flex-wrap
							"
					>
						<div className="flex items-center">
							<div
								className="
									h-6 w-6
									flex items-center justify-center
									rounded-full
                                    bg-[#fedddd] 
									text-[#FA9499]
									"
							>
								<AiOutlineUserAdd />
							</div>
							<h1 className="ml-2 text-darker">User Registrations</h1>
						</div>

						<Select
							className="text-sm"
							styles={settings.selectStyles}
							options={[
								{ value: "30", label: "Last 30 Days" },
								{ value: "6", label: "Last 6 Months" },
								{ value: "12", label: "Last Year" },
							]}
							defaultValue={{ value: "30", label: "Last 30 Days" }}
							onChange={(e) => setRegistrationsType(e.value)}
						/>
					</div>

					{/* data */}
					<div className="my-auto w-full">
						<div className="w-fit mx-auto">
							<h1 className="text-3xl font-medium tracking-tighter text-center">
								{registrationsType === "30" &&
									trendsData.newRegistrations.last30Days.toLocaleString()}
								{registrationsType === "6" &&
									trendsData.newRegistrations.last6Months.toLocaleString()}
								{registrationsType === "12" &&
									trendsData.newRegistrations.lastYear.toLocaleString()}

								<span className="text-base tracking-normal ml-2">Accounts</span>
							</h1>
							<h2
								className="text-dark 
											mt-1 
											text-center
											"
							>
								New accounts registration
							</h2>
						</div>
					</div>
				</div>
			</div>

			{/* MIDDLE CARDS ROW */}
			<div className="MIDDLE-CARDS flex flex-col md:flex-row md:items-stretch md:justify-between md:flex-wrap md:mt-2 flex-1">
				{/* card 1 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="
					min-h-[380px] sm:min-h-[480px] 
					sm:min-w-[500px] 
					flex-1 
					rounded-md
					max-sm:max-w-full 
                    p-5 m-2
                    bg-white 
                    flex flex-col
                    duration-150 ease-in-out
                    overflow-hidden
                    "
				>
					{/* heading */}
					<div className="pl-2 pb-7 w-full">
						<div
							className="
							w-full
							px-2 
							flex 
							items-center justify-between 
							flex-wrap
							"
						>
							<div className="flex items-center justify-between">
								<h1 className="text-xl">Trends</h1>
							</div>

							<Select
								className="text-sm z-50"
								styles={settings.selectStyles}
								options={[
									{ value: "all-time", label: "All Time" },
									{ value: "yearly", label: "Yearly" },
								]}
								defaultValue={{ value: "all-time", label: "All Time" }}
								onChange={(e) => setTrendType(e.value)}
							/>
						</div>

						<p className="text-dark text-sm pl-2">
							Air Space popularity trends
						</p>
					</div>

					{/* data */}
					<div className="w-full flex-1 overflow-hidden">
						{trendType === "all-time" ? (
							<Chart
								options={settings.yearlyTrendGraph.options}
								series={[
									{
										name: "Activity",
										data: trendsData.allTime.map((x) =>
											x.activity.reduce((sum, cur) => sum + cur)
										),
									},
									{
										name: "New Registrations",
										data: trendsData.allTime.map((x) =>
											x.registrations.reduce((sum, cur) => sum + cur)
										),
									},
									{
										name: "Clicks",
										data: trendsData.allTime.map((x) =>
											x.clicks.reduce((sum, cur) => sum + cur)
										),
									},
								]}
								type="area"
								height="100%"
								width="100%"
							/>
						) : (
							<Components.Carousel slidesTotal={trendsData.allTime.length}>
								{trendsData.allTime.map(
									({ year, activity, clicks, registrations }, index) => (
										<Slide
											key={index}
											index={index}
											className="w-full bg-transparent
											overflow-hidden"
										>
											<div className="w-full flex flex-col">
												<h1 className="border-2 rounded w-fit px-2 font-medium text-darker">
													{year}
												</h1>
												<Chart
													options={settings.yearlyTrendGraph.options}
													series={[
														{
															name: "Activity",
															data: activity,
														},
														{
															name: "Clicks",
															data: clicks,
														},
														{
															name: "New Registrations",
															data: registrations,
														},
													]}
													type="area"
													height="350px"
													width="100%"
												/>
											</div>
										</Slide>
									)
								)}
							</Components.Carousel>
						)}
					</div>
				</div>
			</div>

			{/* BOTTOM CARDS ROW */}
			<div className="BOTTOM-CARDS flex flex-col md:flex-row md:items-stretch md:justify-between md:flex-wrap md:mt-2 flex-1">
				{/* card 1 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="
					min-h-[380px] sm:min-h-[480px] 
					sm:min-w-[400px] 
					flex-[2] 
					max-sm:max-w-full 
                    p-5 m-2
					bg-white 
					rounded-md
					flex flex-col
		            duration-150 ease-in-out
					"
				>
					{/* heading */}
					<div className="px-2 pb-2 w-full">
						<div className="flex items-center justify-between">
							<h1 className="text-xl">Activity In Cities</h1>
							<button
								className="text-xs text-main hover:opacity-80"
								onClick={() => navigate("/trends/ps")}
							>
								View Details
							</button>
						</div>
						<p className="text-dark text-sm">
							Parking space activity in cities
						</p>
					</div>

					{/* data */}
					<div className="w-full flex-1 overflow-hidden">
						<AnychartReactMin {...settings.cityTrendGraph} />
					</div>
				</div>
			</div>
		</div>
	);
}
